import BaseService from '../../BaseService'

export default class GPImportService extends BaseService {

  constructor() {
    super('gp/import')
  }

  async downloadTemplate() {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}/template`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

}
